import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { E_ZIndexes } from '@/helpers/consts'


export const SC_TopBarWrapper = styled.div`
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 520px;
  padding: calc(8px + env(safe-area-inset-top, 0px)) 16px 8px;
  box-sizing: border-box;
  z-index: ${E_ZIndexes.Level4};
  background-color: ${E_Colors.White};
  border-radius: 0 0 24px 24px;
  height: calc(60px + env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 700px) {
    border-radius: 0;
  }
`

export const SC_LeftSide = styled.div`
  cursor: pointer;
`

export const SC_RightSide = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  > span {
    font-weight: 600;
    font-size: 16px;
  }
`

export const SC_TopMenuWrapper = styled.div`
  position: relative;
`

export const SC_DropdownMenu = styled.div`
  position: absolute;
  width: 230px;
  top: calc(100% + 4px);
  right: 0;
  padding: 8px 14px;
  border-radius: 8px;
  background-color: ${E_Colors.White};
  box-shadow: 0px 9px 40px 0px rgba(0, 0, 0, 0.105);

  > * {
    white-space: pre;
    cursor: pointer;
  }

  & {
    font-size: 16px;
    line-height: 2.2;
    font-weight: 500;
  }

  & :last-child {
    color: ${E_Colors.EraRed};
  }
`

export const SC_OfflineIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  color: ${E_Colors.EraRed};
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
`
